import { curry, isEmpty, intersection } from 'lodash/fp';
export default curry(function (items, allItems) {
  return !isEmpty(intersection(items, allItems));
});